import { getSeason, KITCHEN_NOTE } from "../../config/hours";
import { GOOD_TO_KNOW } from "../../config/content";

// Klebende Abschnittsmarke links im Raster ("01 — Was wir kochen").
export const SectionLabel = ({ children, light = false }) => (
    <div className={"eyebrow sticky-label" + (light ? " !text-messing-hell" : "")}>{children}</div>
);

// Seitenkopf mit Eyebrow links und H1 (+ Lead) rechts.
export const PageHead = ({ eyebrow, title, lead, children, className = "" }) => (
    <section className={`sec page-head grid-2 !items-end pb-16 ${className}`}>
        <div className="eyebrow hero-in" style={{ animationDelay: ".1s" }}>
            {eyebrow}
        </div>
        <div className="hero-in" style={{ animationDelay: ".25s" }}>
            <h1 className="h1-page m-0">{title}</h1>
            {lead && <p className="lead mt-6 mb-0 max-w-[560px]">{lead}</p>}
            {children}
        </div>
    </section>
);

// Öffnungszeiten als zweispaltige Liste (aktuelle Saison, wenn nicht anders angegeben).
export const HoursList = ({ season = getSeason(), className = "", withNote = true }) => (
    <>
        <div
            className={`grid grid-cols-[auto_1fr] gap-x-10 gap-y-3 border-t border-forest/20 pt-5 text-base leading-normal max-w-[440px] ${className}`}
        >
            {season.rows.map((row) => (
                <div key={row.days} className="contents">
                    <span className="text-forest/70">{row.days}</span>
                    <span>
                        {row.hours.join(" · ")}
                        {row.note && <span className="block text-sm text-forest/70">{row.note}</span>}
                    </span>
                </div>
            ))}
        </div>
        {withNote && (
            <div className="mt-4 max-w-[440px] text-sm text-forest/70">
                {KITCHEN_NOTE} {season.title}.
            </div>
        )}
    </>
);

// Hinweis auf KI-Bildern, die nach dem Shooting ersetzt werden. Das Elternelement braucht
// "relative"; Position per className überschreibbar.
export const PlaceholderBadge = ({ className = "left-3 top-3" }) => (
    <span
        className={`pointer-events-none absolute z-[4] bg-messing-hell px-2.5 py-1 text-xs font-semibold uppercase tracking-[.16em] text-forest shadow-[0_2px_8px_rgba(14,22,18,.25)] ${className}`}
    >
        Platzhalter
    </span>
);

// Kennzeichnung hinter dem Namen eines Gerichts
export const VegetarianMark = () => (
    <span className="ml-2.5 whitespace-nowrap align-[2px] text-xs font-semibold uppercase tracking-[.14em] text-erfolg">
        vegetarisch
    </span>
);

// Eckdaten als Liste mit Linien ("Parken … kostenfrei"). rows: [[Begriff, Wert], …]
// light: für dunkle Abschnitte
export const FactList = ({ rows, className = "", light = false }) => (
    <dl className={`m-0 border-t text-base ${light ? "border-creme/25" : "border-forest/20"} ${className}`}>
        {rows.map(([label, value]) => (
            <div
                key={label}
                className={`flex justify-between gap-6 border-b py-3.5 ${light ? "border-creme/15" : "border-forest/10"}`}
            >
                <dt className="flex-none">{label}</dt>
                <dd className={`m-0 text-right ${light ? "text-creme/60" : "text-forest/70"}`}>{value}</dd>
            </div>
        ))}
    </dl>
);

// "Gut zu wissen": Parken, Anfahrt, Bezahlen …
export const GoodToKnow = ({ className = "" }) => (
    <div className={className}>
        <div className="eyebrow mb-4">Gut zu wissen</div>
        <FactList rows={GOOD_TO_KNOW} />
    </div>
);
